import { WIDTH } from "@/constants"
import GridContainer from "@/components/common/GridContainer"
import React from "react"
import styled from "styled-components"
import { getCssSizeValue, getPropSafely } from "@/utils/utils"
import { BREAKPOINTS } from "@/styles/themeSettings"
import dynamic from "next/dynamic"
import Loading from "@/components/common/Loading"
import { useStructuredContext } from "@/components/common/StructuredText"
import Asset from "@/components/common/StructuredText/common/Asset"

// const Asset = dynamic(() => import("@/components/common/StructuredText/common/Asset"), {
// 	loading: () => <Loading />,
// 	ssr: false,
// })

const StyledVideoContainer = styled.div`
	margin-top: ${getCssSizeValue(32, BREAKPOINTS.MOBILE)};
	margin-bottom: ${getCssSizeValue(32, BREAKPOINTS.MOBILE)};

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		margin-top: ${getCssSizeValue(64, BREAKPOINTS.TABLET)};
		margin-bottom: ${getCssSizeValue(64, BREAKPOINTS.TABLET)};
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		margin-top: ${getCssSizeValue(64, BREAKPOINTS.DESKTOP)};
		margin-bottom: ${getCssSizeValue(64, BREAKPOINTS.DESKTOP)};
	}
`

export default function VideoBlock({ data }) {
	const indent = useStructuredContext("indent")
	const width = useStructuredContext("width")
	const id = data?.id || ""
	// const videoWidth = data?.width || WIDTH.FULL
	const videoWidth = getPropSafely(data, "width", WIDTH.FULL)
	const isFullwidth = videoWidth === WIDTH.FULL
	return (
		<StyledVideoContainer key={id}>
			{isFullwidth ? (
				<GridContainer>
					<Asset id={id} data={data} asset={data?.video} className="col-mobile-8 col-tablet-8 col-desktop-16" />
				</GridContainer>
			) : (
				<Asset
					id={id}
					data={data}
					asset={data?.video}
					className={`indent-desktop-${indent} col-mobile-8 col-tablet-8 col-desktop-${width}`}
				/>
			)}
		</StyledVideoContainer>
	)
}